import React from "react";
// @material-ui/core components
import { useTheme } from "@material-ui/core/styles";
import Badge from "@material-ui/core/Badge";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
// @material-ui/lab components
// @material-ui/icons components
import Code from "@material-ui/icons/Code";
import Notifications from "@material-ui/icons/Notifications";
import ThumbUp from "@material-ui/icons/ThumbUp";
// core components
import SimpleHeader from "components/Headers/SimpleHeader.js";

const items = [
  {
    icon: Notifications,
    title: "New message",
    color: "Success",
  },
  {
    icon: Code,
    title: "Product issue",
    color: "Error",
  },
  {
    icon: ThumbUp,
    title: "New likes",
    color: "Info",
  },
  {
    icon: Notifications,
    title: "New message",
    color: "Success",
  },
  {
    icon: Code,
    title: "Product issue",
    color: "Error",
  },
];

const Timeline = () => {
  const theme = useTheme();
  return (
    <>
      <SimpleHeader section="Timeline" subsection="Pages" />
      {/* Page content */}
      <Container
        maxWidth={false}
        component={Box}
        sx={{
          marginTop: "-4.5rem",
          [theme.breakpoints.up("md")]: {
            paddingLeft: "30px",
            paddingRight: "30px",
          },
        }}
      >
        <Grid container>
          <Grid item xs={12} lg={6}>
            <Card elevation={0}>
              <CardHeader
                sx={{ backgroundColor: "initial" }}
                title="Timeline"
                titleTypographyProps={{
                  component: Box,
                  sx: { marginBottom: "0!important" },
                  variant: "h3",
                }}
              ></CardHeader>
              <CardContent>
                <Box
                  sx={{
                    position: "relative",
                    "&:before": {
                      [theme.breakpoints.up("md")]: {
                        marginLeft: "-2px",
                      },
                      content: "''",
                      position: "absolute",
                      top: 0,
                      left: "1rem",
                      height: "100%",
                      borderRight: "2px dashed " + theme.palette.gray[200],
                    },
                    "& .timeline-content": {
                      width: "auto",
                      [theme.breakpoints.up("md")]: {
                        maxWidth: "30rem",
                      },
                    },
                    "& .MuiBadge-root": {
                      [theme.breakpoints.up("md")]: {
                        left: "-2px",
                      },
                    },
                    "& .timeline-block": {
                      "&:nth-of-type(2n) .timeline-content": {
                        float: "none",
                      },
                    },
                  }}
                >
                  {items.map((prop, key) => (
                    <Box
                      key={key}
                      className="timeline-block"
                      sx={{
                        position: "relative",
                        margin: "2rem 0",
                        "&:first-of-type": {
                          marginTop: 0,
                        },
                        "&:last-of-type": {
                          marginBottom: 0,
                        },
                        "&:after": {
                          content: "''",
                          display: "table",
                          clear: "both",
                        },
                        "&:nth-of-type(2n) .timeline-content": {
                          float: "right",
                        },
                      }}
                    >
                      <Badge
                        badgeContent={<prop.icon />}
                        color={prop.color.toLowerCase()}
                        variant="relative"
                        sx={{
                          position: "absolute",
                          [theme.breakpoints.up("md")]: {
                            left: "47.5%",
                          },
                          "& .MuiBadge-badge": {
                            width: "33px!important",
                            height: "33px!important",
                            borderRadius: "50%!important",
                            display: "inline-flex!important",
                          },
                        }}
                      ></Badge>
                      <Box
                        className="timeline-content"
                        sx={{
                          marginLeft: "60px",
                          paddingTop: ".5rem",
                          position: "relative",
                          top: " -6px",
                          [theme.breakpoints.up("md")]: {
                            width: "38%",
                          },
                        }}
                      >
                        <Box
                          component="small"
                          sx={{
                            fontSize: "80%",
                            fontWeight: "600",
                          }}
                        >
                          10:30
                        </Box>
                        <Typography
                          component="h5"
                          variant="h5"
                          sx={{ marginBottom: 0, marginTop: "1rem" }}
                        >
                          {prop.title}
                        </Typography>
                        <Box
                          component="p"
                          sx={{
                            marginBottom: "0",
                            fontWeight: "300",
                            lineHeight: "1.7",
                            fontSize: ".875rem",
                            marginTop: ".5rem",
                          }}
                        >
                          Nullam id dolor id nibh ultricies vehicula ut id elit.
                          Cum sociis natoque penatibus et magnis dis parturient
                          montes, nascetur ridiculus mus.
                        </Box>
                        <Box sx={{ marginTop: "1rem" }}>
                          <Badge
                            badgeContent={"design"}
                            color={prop.color.toLowerCase()}
                            variant="relative"
                            overlap="circular"
                            sx={{ marginRight: ".5rem" }}
                          ></Badge>
                          <Badge
                            badgeContent={"system"}
                            color={prop.color.toLowerCase()}
                            variant="relative"
                            overlap="circular"
                            sx={{ marginRight: ".5rem" }}
                          ></Badge>
                          <Badge
                            badgeContent={"creative"}
                            color={prop.color.toLowerCase()}
                            variant="relative"
                            overlap="circular"
                            sx={{ marginRight: ".5rem" }}
                          ></Badge>
                        </Box>
                      </Box>
                    </Box>
                  ))}
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} lg={6}>
            <Card
              elevation={0}
              sx={{
                backgroundColor: theme.palette.dark.main,
                "& p,& h5, & smal, & div": {
                  color: theme.palette.white.main,
                },
              }}
            >
              <CardHeader
                sx={{ backgroundColor: "initial" }}
                title="Dark timeline"
                titleTypographyProps={{
                  component: Box,
                  sx: { marginBottom: "0!important" },
                  variant: "h3",
                }}
              ></CardHeader>
              <CardContent>
                <Box
                  sx={{
                    position: "relative",
                    "&:before": {
                      [theme.breakpoints.up("md")]: {
                        marginLeft: "-2px",
                      },
                      content: "''",
                      position: "absolute",
                      top: 0,
                      left: "1rem",
                      height: "100%",
                      borderRight: "2px dashed " + theme.palette.gray[200],
                    },
                    "& .timeline-content": {
                      width: "auto",
                      [theme.breakpoints.up("md")]: {
                        maxWidth: "30rem",
                      },
                    },
                    "& .MuiBadge-root": {
                      [theme.breakpoints.up("md")]: {
                        left: "-2px",
                      },
                    },
                    "& .timeline-block": {
                      "&:nth-of-type(2n) .timeline-content": {
                        float: "none",
                      },
                    },
                  }}
                >
                  {items.map((prop, key) => (
                    <Box
                      key={key}
                      className="timeline-block"
                      sx={{
                        position: "relative",
                        margin: "2rem 0",
                        "&:first-of-type": {
                          marginTop: 0,
                        },
                        "&:last-of-type": {
                          marginBottom: 0,
                        },
                        "&:after": {
                          content: "''",
                          display: "table",
                          clear: "both",
                        },
                        "&:nth-of-type(2n) .timeline-content": {
                          float: "right",
                        },
                      }}
                    >
                      <Badge
                        badgeContent={<prop.icon />}
                        color={prop.color.toLowerCase()}
                        variant="relative"
                        sx={{
                          position: "absolute",
                          [theme.breakpoints.up("md")]: {
                            left: "47.5%",
                          },
                          "& .MuiBadge-badge": {
                            width: "33px!important",
                            height: "33px!important",
                            borderRadius: "50%!important",
                            display: "inline-flex!important",
                          },
                        }}
                      ></Badge>
                      <Box
                        className="timeline-content"
                        sx={{
                          marginLeft: "60px",
                          paddingTop: ".5rem",
                          position: "relative",
                          top: " -6px",
                          [theme.breakpoints.up("md")]: {
                            width: "38%",
                          },
                        }}
                      >
                        <Box
                          component="small"
                          sx={{
                            fontSize: "80%",
                            fontWeight: "600",
                          }}
                        >
                          10:30
                        </Box>
                        <Typography
                          component="h5"
                          variant="h5"
                          sx={{ marginBottom: 0, marginTop: "1rem" }}
                        >
                          {prop.title}
                        </Typography>
                        <Box
                          component="p"
                          sx={{
                            marginBottom: "0",
                            fontWeight: "300",
                            lineHeight: "1.7",
                            fontSize: ".875rem",
                            marginTop: ".5rem",
                          }}
                        >
                          Nullam id dolor id nibh ultricies vehicula ut id elit.
                          Cum sociis natoque penatibus et magnis dis parturient
                          montes, nascetur ridiculus mus.
                        </Box>
                        <Box sx={{ marginTop: "1rem" }}>
                          <Badge
                            badgeContent={"design"}
                            color={prop.color.toLowerCase()}
                            variant="relative"
                            overlap="circular"
                            sx={{ marginRight: ".5rem" }}
                          ></Badge>
                          <Badge
                            badgeContent={"system"}
                            color={prop.color.toLowerCase()}
                            variant="relative"
                            overlap="circular"
                            sx={{ marginRight: ".5rem" }}
                          ></Badge>
                          <Badge
                            badgeContent={"creative"}
                            color={prop.color.toLowerCase()}
                            variant="relative"
                            overlap="circular"
                            sx={{ marginRight: ".5rem" }}
                          ></Badge>
                        </Box>
                      </Box>
                    </Box>
                  ))}
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default Timeline;
